import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from "@angular/core";

/**
 * A searchable single-select for long field lists (taxonomy has ~215 fields). Shows the current
 * value; opening reveals a search box that filters the options. Two-way bindable via [(value)].
 */
@Component({
    selector: "maia-field-select",
    templateUrl: "./maia-field-select.component.html",
    styleUrls: ["./maia-field-select.component.scss"],
})
export class MaiaFieldSelectComponent {
    @Input() options: string[] = [];
    @Input() value = "";
    @Input() placeholder = "Select…";
    @Input() disabled = false;

    @Output() readonly valueChange = new EventEmitter<string>();

    open = false;
    search = "";

    constructor(private readonly host: ElementRef<HTMLElement>) {}

    get filtered(): string[] {
        const q = this.search.trim().toLowerCase();
        return q ? this.options.filter((o) => o.toLowerCase().includes(q)) : this.options;
    }

    toggle(): void {
        if (this.disabled) {
            return;
        }
        this.open = !this.open;
        if (this.open) {
            this.search = "";
        }
    }

    select(option: string): void {
        this.value = option;
        this.valueChange.emit(option);
        this.open = false;
    }

    @HostListener("document:click", ["$event"])
    onDocumentClick(event: MouseEvent): void {
        if (this.open && !this.host.nativeElement.contains(event.target as Node)) {
            this.open = false;
        }
    }
}
